import React, { useState } from 'react';
import { HowToReg, Close } from '@mui/icons-material';
import { Button, Divider } from '@mui/material';
import TextInput from 'Components/FormComponents/TextInput';
import { getPassword } from 'Utils/Password';
import { changePassword } from 'Api/employeeAsess';
import {
  ModalContainer,
  Header,
  Body,
  ButtonContainer,
  inputStyle,
  FloatingClose,
  acceptButton,
  cancelButton,
  titleStyle,
  iconStyle,
  IconContainer,
  hrStyle,
} from './style';

function ResetPasswordModal({ isAdmin, t2, setOpen, setAlertOpen, setError, id }) {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    repeatNewPassword: '',
  });
  const originalPassword = getPassword('password');
  const [errors, setErrors] = useState();

  const handleChange = event => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const validate = () => {
    const temp = {};

    if (!isAdmin) {
      if (formData.currentPassword?.length > 0) {
        temp.currentPassword = formData.currentPassword === originalPassword ? '' : t2('ErrorIncorrectPassword');
      } else {
        temp.currentPassword = formData.currentPassword.length > 0 ? '' : t2('ErrorPasswordBlank');
      }
    }
    temp.newPassword = formData.newPassword.length >= 6 ? '' : t2('ErrorPasswordLength');
    temp.repeatNewPassword = formData.repeatNewPassword.length > 0 ? '' : t2('ErrorPasswordBlank');
    temp.repeatNewPassword = formData.newPassword === formData.repeatNewPassword ? '' : t2('ErrorPasswordsDontMatch');

    setErrors({
      ...temp,
    });

    return Object.values(temp).every(x => x === '');
  };

  const handleSubmit = async () => {
    const isValid = validate();

    if (isValid) {
      const response = await changePassword({
        oldPassword: !isAdmin ? formData.currentPassword : originalPassword,
        newPassword: formData.newPassword,
        isAdmin,
        id,
      });

      if (response?.transactionStatus === true) {
        setOpen(false);
        setAlertOpen(true);
      } else {
        setOpen(false);
        setError(true);
        setAlertOpen(true);
      }
    }
  };

  return (
    <ModalContainer>
      <Header>
        <IconContainer>
          <HowToReg sx={{ width: 40, height: 40 }} style={iconStyle} />
        </IconContainer>
        <FloatingClose>
          <Close sx={{ width: 25, height: 25 }} onClick={() => setOpen(false)} />
        </FloatingClose>
      </Header>
      <Body>
        <div style={titleStyle}>{t2('ResetPassword')}</div>
        {!isAdmin && (
          <TextInput
            name="currentPassword"
            label={t2('CurrentPassword')}
            type="password"
            color="MexlogGreen"
            value={formData?.currentPassword}
            onChange={handleChange}
            style={inputStyle}
            errortext={errors?.currentPassword}
          />
        )}
        <TextInput
          name="newPassword"
          label={t2('NewPassword')}
          type="password"
          color="MexlogGreen"
          value={formData?.newPassword}
          onChange={handleChange}
          style={inputStyle}
          errortext={errors?.newPassword}
        />
        <TextInput
          name="repeatNewPassword"
          label={t2('RepeatNewPassword')}
          type="password"
          color="MexlogGreen"
          value={formData?.repeatNewPassword}
          onChange={handleChange}
          style={inputStyle}
          errortext={errors?.repeatNewPassword}
        />
      </Body>
      <>
        <hr style={hrStyle} />
        <ButtonContainer>
          <Button variant="outlined" color="success" style={cancelButton} onClick={() => setOpen(false)}>
            {t2('Cancel')}
          </Button>
          <Button variant="contained" color="success" style={acceptButton} onClick={handleSubmit}>
            {t2('Reset')}
          </Button>
        </ButtonContainer>
      </>
    </ModalContainer>
  );
}

export default ResetPasswordModal;
